import { render, staticRenderFns } from "./createTenant.vue?vue&type=template&id=dbc539f6"
import script from "./createTenant.vue?vue&type=script&lang=js"
export * from "./createTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports